export const GAP = 20;

export const MIN_COLUMN_WIDTH = 200;
export const MAX_COLUMN_WIDTH = 600;
export const SMALL_BREAKPOINT = MIN_COLUMN_WIDTH * 2;
export const SMALL_BREAKPOINT_MOBILE_COMPARISON = SMALL_BREAKPOINT + 80;
export const MEDIUM_BREAKPOINT = MIN_COLUMN_WIDTH * 3 + 100;
